import * as Sentry from '@sentry/vue';

/**
 * Initialize Sentry for error tracking and monitoring
 * @param {Vue} app - The Vue application instance
 * @returns {Object|null} - The initialized Sentry instance or null if not configured
 */
export function initSentry(app) {
  const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

  if (!sentryDsn) {
    console.warn('Sentry DSN not found in environment variables. Sentry will not be initialized.');
    return null;
  }

  Sentry.init({
    app,
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'testing',
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) || 1.0,
    replaysSessionSampleRate:
      parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE) || 0.1,
    replaysOnErrorSampleRate:
      parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE) || 1.0,
    sendDefaultPii: false,
    initialScope: {
      tags: {
        component: 'Vue App',
        platform: 'vue.js',
      },
      contexts: {
        app: {
          name: 'Trualta Frontend',
        },
      },
    },
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  });

  return Sentry;
}

/**
 * Creates a Sentry plugin for Pinia store
 * @returns {Function} - Pinia plugin function
 */
export function createSentryPiniaPlugin() {
  return Sentry.createSentryPiniaPlugin();
}
